import { render, staticRenderFns } from "./storehouseAgeSearch.vue?vue&type=template&id=19001320&scoped=true&"
import script from "./storehouseAgeSearch.vue?vue&type=script&lang=js&"
export * from "./storehouseAgeSearch.vue?vue&type=script&lang=js&"
import style0 from "./storehouseAgeSearch.vue?vue&type=style&index=0&id=19001320&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19001320",
  null
  
)

component.options.__file = "storehouseAgeSearch.vue"
export default component.exports